import React from 'react';
import { TypeIcon, SunIcon } from 'lucide-react';
const AccessibilityControls = ({
  fontSize,
  setFontSize,
  highContrast,
  setHighContrast
}) => {
  return <div className="fixed top-4 right-4 z-50 flex space-x-2" data-id="element-25">
      <button onClick={() => setFontSize(fontSize === 'normal' ? 'large' : 'normal')} className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition duration-300" aria-label={fontSize === 'normal' ? 'Increase font size' : 'Normal font size'} title={fontSize === 'normal' ? 'Increase font size' : 'Normal font size'} data-id="element-26">
        <TypeIcon size={18} data-id="element-27" />
      </button>
      <button onClick={() => setHighContrast(!highContrast)} className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition duration-300" aria-label={highContrast ? 'Normal contrast' : 'High contrast'} title={highContrast ? 'Normal contrast' : 'High contrast'} data-id="element-28">
        <SunIcon size={18} data-id="element-29" />
      </button>
    </div>;
};
export default AccessibilityControls;